<!-- 상품옵션 견적요청 내역 -->
<template>
  <div>
    <!--<label>
      <input class="input"
             :id="'file-img'+idx"
             type="file"
             @change="onFileChange" multiple>
    </label>-->
    <!-- 추가된 첨부파일 -->
    <div
      v-for="(file, idx) in items"
      :key="`file-${idx}`"
      class="file-list">
      <div class="file-name">{{ file.name }}</div>
      <div class="trash" @click="onDelete(idx)">
        <i class="material-icons">delete</i>
      </div>
    </div>
    <!-- 첨부파일 추가하기 -->
    <input class="file-input"
           :id="uid"
           @click.stop
           @change="onFileChange"
           :accept="acceptExt"
           type="file">

    <label :for="uid"
           v-if="maxLength > items.length || items.length === 0"
           @click.stop
           class="file-list">
      <div class="file-attachment-text">+ 첨부파일 추가</div>
      <div class="file-attachment">
        <i class="material-icons">attachment</i>
      </div>
    </label>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    props:{
      files: {
        type: [Array,String],
        required: true
      },
      maxLength: {
        type: Number,
        default: 5
      },
      acceptExt: {
        type: String,
        default: 'image/gif, image/jpeg, image/png, .docx, .pptx, .xlsx, .hwp, .pdf'
      }
    },
    data () {
      return {
        uid: '',
        // [ '파일', '파일' ]
        items: [],
        uploadReady: true,        // 초기화 용
        file: undefined
      }
    },
    mounted: function() {
      this.uid = moment().format('SSSS')
      //file 타입인 경우
      if(typeof this.url === 'object') {
        this.set_img(this.img);
      }
      else {
        this.img = this.image(this.url);
      }

      /*if(this.files.length>0) {
        this.files.forEach(file => {
          this.items.push({
            name: file,
            file: file
          });
        });
      }*/
    },
    watch: {
      files(n) {
        console.log('files', n)
        this.items = [];
        this.files.forEach(file => {
          this.items.push({
            name: file,
            file: file
          });
        });
      }
    },
    created (){
      if (this.files) {
        this.items = [];
        this.files.forEach(file => {
          this.items.push({
            name: file,
            file: file
          });
        });
      }
    },
    methods: {
      onDelete(idx) {
        removeIndex(this.items, idx);
        this.$emit('remove', idx);
      },
      onFileChange: function(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;

        let reader = new FileReader();
        reader.onload = function(e) {
          this.items[this.items.length-1].file = e.target.result;
          let files = [];
          this.items.forEach(item=> {
            files.push(item.file);
          });
          this.$emit('update:files', files);
          this.$emit('isHide')
        }.bind(this);
        reader.readAsDataURL(files[0]);
        this.items.push({
          name: files[0].name,
          file: ''
        });
      },
      isImage(ext) {
        let isImg = false;
        let imgExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'tiff', 'tif'];
        ext = ext.toLowerCase();
        if(imgExt.indexOf(ext)>-1)
          isImg = true;

        return isImg;
      },
      extColor(ext) {
        let deco = { backgroundColor : '' };
        switch(ext.toLowerCase()) {
          case 'hwp':
            deco.backgroundColor = '#2ebcee';
            break;
          case 'pdf':
            deco.backgroundColor = '#ef4037';
            break;
          case 'docx':
            deco.backgroundColor = '#295498';
            break;
          case 'pptx':
            deco.backgroundColor = '#d14425';
            break;
          case 'xlsx':
            deco.backgroundColor = '#207245';
            break;
        }

        return deco;
      },
      upper(ext) {
        return ext.toUpperCase();
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .file-list
    border 1px solid #eeeeee
    background-color #ffffff
    display flex
    justify-content space-between
    width 100%
    height 46px
    margin-top 8px

  .thumb
  .file-attachment
    width 44px
    height 44px

  .ext
    text-align center
    color white
    background-color #064160
    line-height 44px
    font-size 0.7rem
    font-weight 100

  .file-attachment-text
    padding-left 12px
    line-height 46px
    font-size 0.9rem
    color rgba(162, 174, 186, 1)

  .file-attachment
    background-color rgba(255, 219, 70, 1)
    text-align center

  .file-attachment i
    line-height 46px
    font-size 1.6rem

  .file-desc
    font-size 0.7rem
    color rgba(162, 174, 186, 1)
    white-space pre-line
    padding 8px 0

  .file-name
    padding 0 20px
    color #303841
    font-size 0.8rem
    text-overflow ellipsis
    overflow hidden
    white-space pre
    height 100%
    line-height 44px
    text-align left
    flex 1
    max-width: unset

  .file-input
    width 0
    height 0
    position fixed
    top -100px
    left -100px

  .trash
    width 44px
    height 44px
    text-align center

  .trash i
    line-height 44px
    color rgba(162, 174, 186, 1)
    font-size 1.4rem

</style>
